import { clientSDK, clientV3SDK } from "@istari-frontend/api-client";
import { queryOptions } from "@tanstack/react-query";

import { DEFAULT_CACHE_TIME } from "~/constants";

import { userQueryKeys } from "./user-query-keys";
import { userToInternalUser } from "./user-to-internal-user";

export const userQueryOptions = {
  all: () =>
    queryOptions({
      queryKey: userQueryKeys.all,
      queryFn: () =>
        clientSDK.listUsers("active", "human").catch((err: Error) => {
          throw new Error("An error occurred while loading user list ", err);
        }),
      staleTime: DEFAULT_CACHE_TIME,
      refetchOnWindowFocus: false,
    }),
  byId: (id: string) =>
    queryOptions({
      queryKey: userQueryKeys.byId(id),
      queryFn: () => clientSDK.getUserById(id),
      select: userToInternalUser,
      staleTime: DEFAULT_CACHE_TIME,
    }),
  byPrincipalIds: (principalIds: string[]) =>
    queryOptions({
      queryKey: userQueryKeys.byPrincipalIds(principalIds),
      queryFn: () => clientV3SDK.batchResolveUsers({ batchResolveUsersRequest: { principalIds } }),
      staleTime: DEFAULT_CACHE_TIME,
    }),
};
